import { BaseComponent } from '../../types';

interface FeatureCardProps extends BaseComponent {
  icon?: string;
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export function FeatureCard({
  className,
  icon,
  title,
  description,
  children,
}: FeatureCardProps) {
  return (
    <div
      className={`flex flex-col items-start ${className || ''}`}
      style={{
        width: '350px',
        minWidth: '300px',
        flex: '1',
        padding: '24px',
        gap: '12px',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.20)',
        background: 'var(--Background, #020816)',
      }}
    >
      {icon && (
        <img
          src={`/icons/${icon}`}
          alt={title || 'Icon'}
          style={{
            width: '40px',
            height: '40px',
          }}
        />
      )}
      {title && (
        <h3
          style={{
            color: 'var(--Text-Secondary, #FFF)',
            fontFamily: 'Inter',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
            alignSelf: 'stretch',
          }}
        >
          {title}
        </h3>
      )}
      {description && (
        <p
          style={{
            color: 'var(--Text-Body-Gray, #989898)',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '24px',
          }}
        >
          {description}
        </p>
      )}
      {children}
    </div>
  );
}
